import './Tooltip.css'

import * as React from 'react'
import ReactTooltipLite, { TooltipProps as ReactTooltipProps } from 'react-tooltip-lite'

import { TOOLTIP_DIRECTIONS } from './constants'

interface TooltipProps {
  content?: React.ReactNode
  direction?: TOOLTIP_DIRECTIONS
  className?: string
  children?: React.ReactNode
}

function Tooltip({
  content,
  direction = TOOLTIP_DIRECTIONS.UP,
  className,
  children,
  ...rest
}: TooltipProps & ReactTooltipProps) {
  return (
    <ReactTooltipLite
      arrowSize={5}
      className={className}
      content={content}
      direction={direction}
      distance={10}
      padding="0"
      mouseOutDelay={200}
      {...rest}
    >
      {children}
    </ReactTooltipLite>
  )
}

export { TOOLTIP_DIRECTIONS }

// TODO: Remove default export
// eslint-disable-next-line import/no-default-export
export default Tooltip
